/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class PartProjectTenantApi {
    static getInstance() {
        if (!this.instance) this.instance = new PartProjectTenantApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取列表
    async getList (param,num,size){
        let url = `/api/sys/tenant/project/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param || {},'POST')
        return result
    }

    // 新增对应关系
    async addPartProjectTenant (param){
        let url = `/api/sys/tenant/project`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑对应关系
    async editPartProjectTenant (param, id){
        let url = `/api/sys/tenant/project/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

}

export {
    PartProjectTenantApi
}